import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PaginatorPtbr extends MatPaginatorIntl {

	constructor(private translate: TranslateService) {
		super();
	}


	getRangeLabel = (page: number, pageSize: number, length: number) => {
		if (length === 0 || pageSize === 0) {
			return this.translate.instant('paginator.emptyRange', { length });
		}
		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
		return this.translate.instant('paginator.range', { start: startIndex + 1, end: endIndex, length });
	};
}
